import React from "react";

const Name = (props) => {
    return (
        <div className='input-details'>
            <input style={props.nameStyleObj}
                value={props.name}    
            />
        </div>
    )};

export default Name;
